module.exports = __webpack_public_path__ + "static/media/ds05.3d9d146f.jpg";